//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { members_cancelList, members_cancelAudit } from '@/apis/members'
export default {
    data() {
        return {
            config: {
            },
            searchQuery: {
                status: '',
                phone: '',
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            approveNoteVisible: false,
            approveNoteTitle: '審批備註',
            modalForm: {
                status: undefined,
                note: undefined
            }
        }
    },
    created() {
        this.columns = [
            { title: '客戶編碼', dataIndex: 'memberCode', key: 'memberCode', width: 220, },
            { title: '客戶名稱', dataIndex: 'memberName', key: 'memberName', width: 200, },
            { title: '客戶手機號', dataIndex: 'memberPhone', key: 'memberPhone', width: 220, },
            { title: '申請時間', dataIndex: 'createdAt', key: 'createdAt', width: 220, },
            { title: '審批狀態', dataIndex: 'approveStatus', key: 'approveStatus', width: 100, scopedSlots: { customRender: 'approveStatus' }, },
            { title: '審批人', dataIndex: 'approver', key: 'approver', width: 120 },
            { title: '審批備註', dataIndex: 'approveNote', key: 'approveNote', width: 200 },
            { title: '審批時間', dataIndex: 'approveTime', key: 'approveTime', width: 230, },
            { title: '操作', key: 'operation', width: 230, scopedSlots: { customRender: 'action' }, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageLoad();
        });
    },
    methods: {
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await members_cancelList({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                }) || {};
                if (res.code == 0) {
                    this.records = res.data.records;
                    this.pagination.total = res.data.total;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },

        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad();
        },
        handleApplyStatus(item, status) {
            this.modalForm.note = undefined;
            this.modalForm.status = status;
            this.modalForm.id = item.id;
            if (status == 1) {
                this.approveNoteTitle = '審批通過備註';
            } else if (status == 2) {
                this.approveNoteTitle = '審批拒絕備註';
            } else {
                this.approveNoteTitle = '';
            }
            this.approveNoteVisible = true;
        },
        async handleApplyNoteOk() {
            try {
                if (this.modalForm.status > 0) {
                    if ((this.modalForm.note || '') != '') {
                        const res = await members_cancelAudit(this.modalForm) || {};
                        if (res.code == 0) {
                            this.approveNoteVisible = false;
                            this.onPageLoad(true);
                        } else {
                            if (res.msg)
                                throw new Error(res.msg);
                        }
                    } else {
                        this.$message.warning('請填寫審批備註');
                    }
                } else {
                    throw new Error('操作數據無狀態');
                }
            } catch (error) {
                console.log(error);
                this.$message.error(error.message);
            }
        }
    }
}
